import React, { useEffect, useMemo, useState } from "react";
import { withUser } from "@coverme/identity";
import { connect } from "react-redux";
import * as casesActions from "../../actions/casesActions";
import { MyCasesFilters } from "../../components/MyCasesFilters/MyCasesFilters";
import { ReportingTable } from "./ReportingTable";
import { MyCasesTable } from "../../components/MyCasesTable/MyCasesTable";

import "../../styles/dashboard.scss";
import { LoadingBar } from "../../components/LoadingComponents/LoadingBar";
import { useFilters } from "../../hooks/useFilters";
import { postAndDownloadFile } from "../../services/fileDownloader";
import * as interviewActions from "../../actions/interviewActions";
import * as lookupActions from "../../actions/lookupActions";
import { getLookups } from "../../actions/lookupActions";
import * as customerActions from "../../actions/customerActions"
import { Birdseed } from "@coverme/elements";
import { Link } from "react-router-dom";
import { DataHolderComponent } from "./DataHolderComponent";
import { CovermeReportingDHComponent } from "./CovermeReportingDHComponent";
import { getDate,addDays, addMonths  } from "date-fns";


export const CovermeReportingComponent = ({
    cases,
    caseMetadata,
    getCases,
    getPrograms,
    getCaseMetadata,
    updateCasesFilter,
    user,
    history,
    customerId,
    customerPrograms,
    customerFeatures,
    setSimplePersonDemographics,
    jurisdiction,
    getLookups,
    lookups,
    getCaseCounts,
    caseCounts,
    getChildFacilities,
    childFacilities,
    customer
}) => {
    const isLoading =
        cases.isInitialized === false ||
        caseMetadata.isInitialized === false ||
        caseMetadata.isLoading === true ||  
        customerId === undefined;
    const [isProgramForm, SetIsProgramForm] = useState(false);
    const [formattedFacility, setFormattedFacility] = useState([]);
    const [selectedCustomer, setSlectedCustomer] = useState(customerId);
    const [startDate, setStartDate] = useState(addMonths(new Date(),-1));
    const [endDate, setEndDate] = useState(new Date());

    // const [selectedCustomer, setSlectedCustomer] = useState(customerId);


    useEffect(() => {

        if (customerId == undefined || customerId == null) {
            return;
        }
        setSlectedCustomer(customerId)
        getCaseMetadata(customerId);
        getPrograms(customerId);
        getLookups(customerId, jurisdiction);
        getChildFacilities(customerId)
    }, [customerId]);

    useEffect(() => {
        if (selectedCustomer == undefined || selectedCustomer == null) {
            return;
        }
        getCaseCounts(customerId,{customerIds:[selectedCustomer],startDate:startDate, endDate:endDate});
    }, [selectedCustomer,startDate,endDate]);

    const { filters, setFilters, onFetchData } = useFilters(
        { includeDependentCustomers: true, includeDependentUsers: true, startDate:startDate, endDate:endDate},
        customerId,
        getCases,
        500,
        20
    );

    const formattedCases = useMemo(() => {
        if (cases.data != null && cases.data != undefined && cases.data.data.length > 0) {
            if (
                lookups?.automatedTags !== undefined &&
                lookups?.automatedTags !== null &&
                lookups?.manualTags !== undefined &&
                lookups?.manualTags !== null
            ) {
                let allTags = [...lookups.automatedTags, ...lookups.manualTags];
                cases.data.data.forEach(item => {
                    item.tagName = "";
                    let tagOption = allTags.filter(x => x.id === item.tag);
                    if (tagOption?.length > 0) {
                        item.tag = tagOption[0].tagName;
                    }
                });
                return cases.data;
            }
        }
        return cases.data;
    }, [cases.data, lookups.data]);
 
    useEffect(() => {
        if (childFacilities) {

            const formattedData = childFacilities?.map(y => {
                return { label: y.name, value: y.GlobalId };
            });

            setFormattedFacility([
                { label: customer?.data?.customer?.name, value: customer?.data?.customer?.GlobalId },
                ...formattedData,
            ]);
        }
    }, [childFacilities]);


    const exportEncounters = formData => {
        postAndDownloadFile(
            `/api/customer/${customerId}/encounters/search/export`,
            {customerIds:[selectedCustomer],startDate:startDate, endDate:endDate, includeDependentCustomers: true, includeDependentUsers: true},
            {},
            false,
            "encounters.csv"
        );
    };

    const SelectedCustomerChanged = (data)=>{
        setSlectedCustomer(data.facilityName)
        setStartDate(data.startDate)
        setEndDate(data.endDate)
    }
  
    return (
        <div className="cases">
            <LoadingBar isLoading={isLoading}>
                <Birdseed>
                    <Link to="/" className="link">
                        Home
                    </Link>
                    <a href="javascript:void(0)">CoverMe KPIs</a>
                </Birdseed>
                <CovermeReportingDHComponent
                    coveragesCount={caseCounts.data.covermeCompleteEncountersWithCoverageCount}
                    filesCount={caseCounts.data.covermeCompleteFilesCount}
                    totalRecordsCount={caseCounts.data.totalCaseCount}
                    completedEncountersCount={caseCounts.data.completedEncountersCount}
                    formattedFacility={formattedFacility}
                    submitFilter={setFilters}
                    selectedCustomerChanged ={SelectedCustomerChanged}
                    selectedCustomer = {selectedCustomer}
                    exportEncounters={exportEncounters}
                    lastMonthTotalCount={caseCounts.data.lastMonthTotalCount}
                    lastMonthFileCount={caseCounts.data.lastMonthFilesCount}
                    LastMonthCoverageCount={caseCounts.data.lastMonthEncountersWithCoverageCount}
                    lastMonthCompletedEncountersCount = {caseCounts.data.lastMonthCompletedEncountersCount}
                    last6MonthsTotalAndCompletedRecordsCount = {caseCounts.data.last6MonthsTotalAndCompletedRecordsCount}
                    encounterswithprogramsCount={caseCounts.data.encounterswithprogramsCount}
                    lastMonthEncounterswithprogramsCount={caseCounts.data.lastMonthEncounterswithprogramsCount}
                    lastMonthEncounterswithCoveragesCount = {caseCounts.data.lastMonthEncounterswithCoveragesCount}
                    encounterswithCoveragesCount = {caseCounts.data.encounterswithCoveragesCount}
                    last6MonthsProgramsCount = {caseCounts.data.last6MonthsProgramsCount}
                ></CovermeReportingDHComponent>
                <MyCasesTable
                    pagedCases={formattedCases}
                    onFetchData={onFetchData}
                    isLoading={cases.isLoading}
                    isProgramForm={isProgramForm}
                    customerFeatures={customerFeatures}
                />

            </LoadingBar>
        </div>
    );
};

export const CovermeReportingComponentWithUser = withUser(CovermeReportingComponent);

export const CovermeReportingContainer = connect(
    state => ({
        cases: state.cases.searchResults,
        caseMetadata: state.cases.searchMetadata,
        customerId: state.customer?.data?.customer?.GlobalId,
        jurisdiction: state.customer.data.jurisdictions,
        customerPrograms: state.customerPrograms.data,
        customerFeatures: state.customer?.data?.features,
        lookups: state.interviewLookups.data || {},
        caseCounts: state.caseCounts,
        childFacilities:state.childFacilities.data,
        customer: state.customer
    }),
    dispatch => ({
        getCases: (customerId, query, cancellationToken) =>
            dispatch(casesActions.getCases(customerId, query, cancellationToken)),
        getCaseMetadata: customerId => dispatch(casesActions.getCaseMetadata(customerId)),
        getPrograms: customerId => dispatch(casesActions.getPrograms(customerId)),
        updateCasesFilter: (filter, query) => dispatch(casesActions.updateCasesFilter(filter, query)),
        setSimplePersonDemographics: data => dispatch(interviewActions.setSimplePersonDemographics(data)),
        getLookups: (customerId, jurisdiction) => dispatch(lookupActions.getLookups(customerId, jurisdiction)),
        getCaseCounts: (customerId,query) => dispatch(casesActions.getCaseCovermeReportingCounts(customerId,query)),
        getChildFacilities: customerId => dispatch(customerActions.getChildFacilities(customerId)),
    })
)(CovermeReportingComponentWithUser);
